if (!customElements.get('icraft-c3-collection')) {
    customElements.define('icraft-c3-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.cards = [...this.querySelectorAll('[data-design-card]')];
        this.grid = this.querySelector('.ic3-grid');
        this.filter = 'all';
        this.querySelectorAll('[data-filter],[data-sort]').forEach(el => { el.disabled = false; });
        this.startCompare = () => {
          if (!this.isConnected) return;
          this.idleCompare = window.requestIdleCallback
            ? window.requestIdleCallback(() => this.initGlobalCompare(), {timeout: 1200})
            : setTimeout(() => this.initGlobalCompare(), 100);
        };
        this.startCompare();
        this.compareFeedbackHandler = event => this.showCompareFeedback(event.detail);
        document.addEventListener('icraft:compare-changed', this.compareFeedbackHandler);
        this.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
          this.filter = button.dataset.filter;
          this.querySelectorAll('[data-filter]').forEach(other => other.setAttribute('aria-pressed',String(other === button)));
          this.updateGrid();
        }));
        this.querySelector('[data-sort]')?.addEventListener('change', () => this.updateGrid());
        this.updateGrid();
        const params = new URL(location.href).searchParams;
        const origin = this.cards.find(card => card.dataset.product === params.get('compare_product') && card.dataset.variant === params.get('compare_variant'));
        if (origin && this.querySelector('.ic3-model-guide')) {
          this.querySelector('.ic3-model-guide').open = true;
          const link = this.querySelector('[data-guide-return]');
          link.href = origin.querySelector('[data-design-url]').href;
          link.textContent = origin.dataset.model + ' · ' + origin.dataset.design;
          link.parentElement.hidden = false;
        }
      }
      showCompareFeedback(detail) {
        if (!detail?.source || !this.contains(detail.source)) return;
        const card = detail.source.closest('[data-design-card]');
        const notice = this.querySelector('.ic3-compare-notice');
        clearTimeout(this.feedbackTimer);
        notice.hidden = false;
        this.querySelector('[data-compare-message]').textContent = this.dataset[detail.action] + ' · ' + card.dataset.design;
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          notice.getAnimations().forEach(animation => animation.cancel());
          notice.animate([{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],{duration:200,easing:'ease-out'});
          const label = detail.source.closest('label');
          label.getAnimations().forEach(animation => animation.cancel());
          label.animate([{transform:'scale(1)'},{transform:'scale(1.09)'},{transform:'scale(1)'}],{duration:400,easing:'ease-out'});
          document.querySelectorAll('.js-compare-counter').forEach(counter => {
            counter.getAnimations().forEach(animation => animation.cancel());
            counter.animate([{transform:'scale(1)'},{transform:'scale(1.5)',color:'#d6002a'},{transform:'scale(1)'}],{duration:450});
          });
        }
        this.feedbackTimer = setTimeout(() => { notice.hidden = true; }, 3800);
      }
      disconnectedCallback() {
        document.removeEventListener('icraft:compare-changed', this.compareFeedbackHandler);
        clearTimeout(this.feedbackTimer);
        if (window.cancelIdleCallback) window.cancelIdleCallback(this.idleCompare);
        else clearTimeout(this.idleCompare);
        this.ready = false;
      }
      async initGlobalCompare() {
        if (!this.isConnected) return;
        const opener = this.querySelector('[data-compare-view]');
        if (!opener || !this.querySelector('.js-compare-checkbox')) return;
        opener.disabled = true;
        const resourcesTag = document.getElementById('compare-resources');
        if (resourcesTag) {
          const resources = JSON.parse(resourcesTag.textContent);
          resourcesTag.remove();
          try {
            for (const resource of resources) {
              if (resource.type === 'css') {
                const link = document.createElement('link');
                link.rel = 'stylesheet'; link.href = resource.path; document.head.append(link);
              } else if (resource.type === 'js') {
                await new Promise((resolve, reject) => {
                  const script = document.createElement('script');
                  script.src = resource.path; script.onload = resolve; script.onerror = reject;
                  document.head.append(script);
                });
              }
            }
          } catch { return; }
        }
        await customElements.whenDefined('compare-drawer');
        if (!this.isConnected) return;
        this.querySelectorAll('.js-compare-checkbox').forEach(input => { input.disabled = false; });
        opener.disabled = false;
        opener.addEventListener('click', event => {
          event.stopPropagation();
          document.querySelector('compare-drawer')?.open(document.querySelector('.js-open-compare-drawer'));
        });
      }
      updateGrid() {
        if (this.hasAttribute('data-server-catalog')) return;
        const sort = this.querySelector('[data-sort]').value;
        const cards = [...this.cards];
        if (sort !== 'featured') cards.sort((a,b) => (Number(a.dataset.price)-Number(b.dataset.price)) * (sort === 'ascending' ? 1 : -1));
        cards.forEach(card => {card.hidden = this.filter !== 'all' && card.dataset.model !== this.filter; this.grid.append(card);});
        this.querySelector('[data-count]').textContent = this.querySelector('[data-count-template]').textContent.replace('[count]',cards.filter(card => !card.hidden).length);
      }
    });
  }
